export const disclaimer = {
    display: true,
    header: "Warning: BETA version",
    text: "Correctness is not guaranteed. Provided plans confer no legal rights regarding studyability.",
    displayLink: true,
    linkText: "We value your feedback!",
};